/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Presencia
 * @export
 * @interface Presence
 */
export interface Presence {
    /**
     * 
     * @type {string}
     * @memberof Presence
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof Presence
     */
    value?: number;
}

export function PresenceFromJSON(json: any): Presence {
    return PresenceFromJSONTyped(json, false);
}

export function PresenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Presence {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function PresenceToJSON(value?: Presence | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'value': value.value,
    };
}


